module.exports = __webpack_public_path__ + "static/media/Close_blue_withoutCircle.2ce617da.svg";